import { render, staticRenderFns } from "./title.vue?vue&type=template&id=61ec3955&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=61ec3955&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec3955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ec3955')) {
      api.createRecord('61ec3955', component.options)
    } else {
      api.reload('61ec3955', component.options)
    }
    module.hot.accept("./title.vue?vue&type=template&id=61ec3955&scoped=true", function () {
      api.rerender('61ec3955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/title.vue"
export default component.exports